export default "__VITE_ASSET__DjRMkyLQ__"